export var ACTION;
(function (ACTION) {
    ACTION["ON_CHANGE_SLIDER"] = "ON_CHANGE_SLIDER";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["GO_CONFIRM_PLEDGE"] = "GO_CONFIRM_PLEDGE";
    ACTION["EDIT_PORTFOLIO"] = "EDIT_PORTFOLIO";
    ACTION["EDIT_LIMIT"] = "EDIT_LIMIT";
    ACTION["UNLOCK_LIMIT"] = "UNLOCK_LIMIT";
    ACTION["GET_MORE_MF_PORTFOLIO"] = "GET_MORE_MF_PORTFOLIO";
    ACTION["REMOVE_GET_MORE_MF_PORTFOLIO"] = "REMOVE_GET_MORE_MF_PORTFOLIO";
    ACTION["MODIFY_LIMIT"] = "MODIFY_LIMIT";
    ACTION["NAV_NEXT"] = "NAV_NEXT";
    ACTION["NAV_PORTFOLIO"] = "NAV_PORTFOLIO";
    ACTION["PORTFOLIO"] = "PORTFOLIO";
    ACTION["VIEW_ALL"] = "VIEW_ALL";
    ACTION["NAV_TO_CONTACT_US"] = "NAV_TO_CONTACT_US";
    ACTION["CHECK_LIMIT"] = "CHECK_LIMIT";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["GO_HOME"] = "GO_HOME";
})(ACTION || (ACTION = {}));
